import React from "react";

interface Props { }

export const SocialShareIconComponent: React.SFC<Props> = () => {
  return (
    // tslint:disable:max-line-length
    <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 9V21H21V12H24V24H0V6H9V9H3Z" fill="white" />
      <path fillRule="evenodd" clipRule="evenodd" d="M14.4541 7.42462L20.9393 0.93934L23.0607 3.06066L16.5754 9.54595C14.6062 11.5151 13.5 14.1858 13.5 16.9706V18H10.5V16.9706C10.5 13.3901 11.9223 9.95637 14.4541 7.42462Z" fill="white" />
      <path d="M21 3H15V0H24V9H21V3Z" fill="white" />
    </svg>
    // tslint:enable:max-line-length
  );
};
